import React from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import { ajax } from "jquery";
import extend from "extend";

export default class CouponController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
        this.state = { code: null, _token: this.props.token };
    }

    onAdd() {
        ajax(this.props.url, {
            data: this.state,
            method: "POST",
            dataType: "json",
            success: (data) => {
                this.store.load(extend({
                    feedback: {
                        message: data.message,
                        type: data.type,
                    },
                }, data.basket));

                if (data.type === "success") {
                    this.setState({ code: "", _token: data.token });
                } else {
                    this.setState({ _token: data.token });
                }
            },
        });
    }

    render() {
        const CouponView = ComponentRegistry.get(this.props.view);

        return (<CouponView
          {...this.props}
          value={this.state.code}
          onAdd={() => this.onAdd()}
          onChange={code => this.setState({ code })}
        />);
    }
}

CouponController.propTypes = {
    store: React.PropTypes.string,
    url: React.PropTypes.string.isRequired,
    token: React.PropTypes.string.isRequired,
    view: React.PropTypes.string.isRequired,
};

CouponController.defaultProps = {
    view: "BasketViewsCouponView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Controllers/CouponController.jsx